/* ===== MedBound — carrello drawer (dual-mode) =====
   SU SHOPIFY (window.MB_VARIANTS iniettato dal layout): usa la Cart AJAX API
   (/cart/add.js, /cart.js, /cart/change.js) con gli ID varianti reali →
   carrello vero, checkout vero, eventi tracciati (pixel/analytics).
   SUL SITO STATICO: fallback localStorage, comportamento demo identico.
   UI invariata: barra spedizione €99 + coriandoli, timer 10 min, stepper,
   upsell con selettore formato, codice sconto. */
(function(){
  const EUR = v => "€" + v.toFixed(2).replace(".", ",");
  const FREE_SHIP = 149;
  const RESERVE_MIN = 10;
  const DISCOUNTS = { "MEDBOUND10": 0.10 }; // demo locale; su Shopify i codici sono veri
  const SHOP = () => !!window.MB_VARIANTS;

  // ---- cataloghi statici (fallback + etichette) ----
  const FMT  = { ebook:{n:"Ebook",p:49.99,c:89.99}, spiral:{n:"Spiralbindung",p:79.99,c:139.99}, combo:{n:"Ebook + Spiralbindung",p:84.99,c:149.99} };
  const BFMT = { ebook:{n:"Digital",p:149.99,c:359.96}, spiral:{n:"Spiralbindung",p:199.99,c:559.96}, combo:{n:"Spiralbindung + Digital",p:219.99,c:599.96} };
  const CATALOG = {
    m2: {t:"Klinische Medizin – M2 Staatsexamen",cover:"/assets/m2-buch-cover-160.webp",stars:0},
    m3: {t:"Fälle & Praxis – M3 Staatsexamen",cover:"/assets/m3-buch-cover-160.webp",stars:0},
    heilpraktiker: {t:"Heilpraktiker werden – Prüfungswissen",cover:"/assets/hp-buch-cover-160.webp",stars:0},
    "m2-lernkarten": {t:"Klinische Medizin – M2 Lernkarten",cover:"/assets/fc-buch-cover-160.webp",stars:0},
    anatomie:  {t:"Band 1 — Anatomie & Physiologie", cover:"assets/store/band1-spiral.png", stars:82},
    physiologie:{t:"Band 2 — Physiologie & Physik",  cover:"assets/store/band2-spiral.png", stars:77},
    biochemie: {t:"Band 3 — Biochemie & Chemie",    cover:"assets/store/band3-spiral.png", stars:74},
    biologie:  {t:"Band 4 — Biologie & PsychSoz",    cover:"assets/store/band4-spiral.png", stars:67},
    bundle:    {t:"Mega Bundle Physikum",            cover:"assets/covers/bundle-mockup.png", stars:332},
  };
  const KEY="mb_cart_v2", DKEY="mb_cart_disc", TKEY="mb_cart_timer";
  const coverOf = id => {
    const mv = (window.MB_VARIANTS||{})[id];
    if(mv && mv.image) return mv.image;
    return (window.MB_ASSETS||{})[id] || (CATALOG[id]||{}).cover;
  };
  const fmtsOf = id => id === "m2-lernkarten" ? {spiral:{n:"Digital",p:44.99,c:0},ebook:{n:"Digital",p:44.99,c:0}} : id === "anatomie" ? {spiral:{n:"Spiralbindung",p:99.99,c:139.99}} : id === "m2" || id === "m3" || id === "heilpraktiker" ? {spiral:{n:"Spiralbindung",p:99.99,c:0}} : id==="bundle" ? BFMT : FMT;
  function fmtOf(v){
    v = (v||"").toLowerCase();
    // combo = qualsiasi etichetta che combina due formati (ha un "+"): es.
    // "E-Book + Spiralbindung", "Spiralbindung + Digital", "Ebook + Spiral".
    if(v.includes("+") || v.includes("combo")) return "combo";
    if(v.includes("spiral")) return "spiral";
    return "ebook";
  }
  // variante Shopify per (handle, fmt)
  const variantFor = (id, fmt) => {
    const e = (window.MB_VARIANTS||{})[id];
    return e ? (e.variants.find(v => fmtOf(v.option) === fmt) || (id === "anatomie" ? e.variants[0] : null) || null) : null;
  };
  const variantById = vid => {
    for(const id in (window.MB_VARIANTS||{})){
      const v = window.MB_VARIANTS[id].variants.find(v => v.id === vid);
      if(v) return Object.assign({handle:id}, v);
    }
    return null;
  };

  // ---- stato carrello unificato: lista di righe {key,id,fmtLabel,qty,unit,line,compare,image,title}
  let cartCache = { items: [], total: 0, count: 0 };

  async function refreshCart(){
    if(SHOP()){
      try{
        const c = await (await fetch("/cart.js", {headers:{"Accept":"application/json"}})).json();
        cartCache = {
          count: c.item_count,
          total: c.total_price / 100,
          items: c.items.map(it => {
            const mv = variantById(it.id);
            const cmp = mv && mv.compare ? mv.compare/100 : null;
            return {
              key: it.key, id: (window.MB_ALIAS||{})[it.handle] || it.handle, title: it.product_title, variantId: it.id,
              fmtLabel: (it.variant_title || "") + (it.handle === "bundle" ? " · 4 Bände" : ""),
              qty: it.quantity,
              line: (it.final_line_price != null ? it.final_line_price : it.line_price) / 100,
              compare: cmp ? cmp * it.quantity : null,
              image: it.image
            };
          })
        };
      }catch(e){ console.warn("[mb-cart] cart.js", e); }
    } else {
      let items = [];
      try { items = JSON.parse(localStorage.getItem(KEY))||[]; } catch(e){}
      const disc = DISCOUNTS[(localStorage.getItem(DKEY)||"").toUpperCase()] || 0;
      let total = 0;
      const lines = items.map(i => {
        const f = fmtsOf(i.id)[i.fmt] || fmtsOf(i.id).ebook;
        total += f.p * i.qty;
        return { key: i.id+"|"+i.fmt, id: i.id, title: (CATALOG[i.id]||{}).t,
          fmtLabel: f.n + (i.id==="bundle" ? " · 4 Bände" : ""), qty: i.qty,
          line: f.p * i.qty, compare: f.c ? f.c*i.qty : null, image: coverOf(i.id) };
      });
      cartCache = { count: items.reduce((n,i)=>n+i.qty,0), total: total*(1-disc), items: lines, rawTotal: total };
    }
  }

  // ---- mutazioni ----
  async function addLine(id, fmt, qty){
    if(!cartCache.count) localStorage.setItem(TKEY, String(Date.now() + RESERVE_MIN*60*1000));
    if(SHOP()){
      const v = variantFor(id, fmt);
      if(!v){ console.warn("[mb-cart] variante non trovata", id, fmt); return; }
      try{
        await fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json"},
          body: JSON.stringify({items:[{id: v.id, quantity: qty}]})});
      }catch(e){ console.warn("[mb-cart] add", e); }
    } else {
      let it = []; try { it = JSON.parse(localStorage.getItem(KEY))||[]; } catch(e){}
      const f = it.find(x => x.id===id && x.fmt===fmt);
      if(f) f.qty += qty; else it.push({id, fmt, qty});
      localStorage.setItem(KEY, JSON.stringify(it));
    }
    await render(); open();
  }
  async function addVariantId(vid, qty){
    if(!cartCache.count) localStorage.setItem(TKEY, String(Date.now() + RESERVE_MIN*60*1000));
    try{
      await fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({items:[{id: vid, quantity: qty}]})});
    }catch(e){ console.warn("[mb-cart] add", e); }
    await render(); open();
  }
  async function setQty(key, qty){
    if(SHOP()){
      try{
        await fetch("/cart/change.js", {method:"POST", headers:{"Content-Type":"application/json"},
          body: JSON.stringify({id: key, quantity: qty})});
      }catch(e){ console.warn("[mb-cart] change", e); }
    } else {
      const [id, fmt] = key.split("|");
      let it = []; try { it = JSON.parse(localStorage.getItem(KEY))||[]; } catch(e){}
      if(qty < 1) it = it.filter(x => !(x.id===id && x.fmt===fmt));
      else { const f = it.find(x => x.id===id && x.fmt===fmt); if(f) f.qty = qty; }
      localStorage.setItem(KEY, JSON.stringify(it));
    }
    await render();
  }
  // cambia il formato di una riga: rimuove la vecchia e aggiunge il nuovo formato (stessa qty)
  async function changeLineFmt(oldKey, id, val, qty){
    if(SHOP()){
      try{
        await fetch("/cart/change.js", {method:"POST", headers:{"Content-Type":"application/json"},
          body: JSON.stringify({id: oldKey, quantity: 0})});
        if(val.indexOf("v:")===0){
          await fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json"},
            body: JSON.stringify({items:[{id: parseInt(val.slice(2),10), quantity: qty}]})});
        }
      }catch(e){ console.warn("[mb-cart] changeFmt", e); }
    } else {
      const oid=oldKey.split("|")[0], ofmt=oldKey.split("|")[1], nf=val.slice(2);
      if(nf===ofmt) return;
      let it = []; try { it = JSON.parse(localStorage.getItem(KEY))||[]; } catch(e){}
      it = it.filter(x => !(x.id===oid && x.fmt===ofmt));
      const ex = it.find(x => x.id===id && x.fmt===nf);
      if(ex) ex.qty += qty; else it.push({id, fmt:nf, qty});
      localStorage.setItem(KEY, JSON.stringify(it));
    }
    await render();
  }

  const open = () => { document.getElementById("mbc-ov").dataset.open="1"; document.getElementById("mbc-dr").dataset.open="1"; };
  const close = () => { document.getElementById("mbc-ov").dataset.open="0"; document.getElementById("mbc-dr").dataset.open="0"; };

  // ---- pagina prodotto ----
  function pageId(){
    const p = (location.pathname.split("/").filter(Boolean).pop()||"").replace(/\.html$/,"");
    return CATALOG[p] ? p : null;
  }
  function currentFmt(){
    const c = document.querySelector('input[name^="Format"]:checked');
    return c ? fmtOf(c.value) : null;
  }
  function currentQty(){
    const q = document.querySelector(".quantity__input");
    const n = q ? parseInt(q.value,10) : 1;
    return n>0 ? n : 1;
  }
  function showFormatError(){
    const fs = document.querySelector(".product__block--variant_picker fieldset");
    if(!fs) return;
    fs.classList.add("mb-fmt-required");
    if(!fs.parentElement.querySelector(".mb-fmt-err")){
      const note = document.createElement("div");
      note.className = "mb-fmt-err";
      note.textContent = "Wähle ein Format, um zum Warenkorb hinzuzufügen";
      fs.insertAdjacentElement("afterend", note);
    }
    fs.scrollIntoView({behavior:"smooth", block:"center"});
  }

  /* ---- timer riserva carrello ---- */
  let timerInt = null;
  function tickTimer(){
    const el = document.getElementById("mbc-timer");
    if(!el) return;
    if(!cartCache.count){ el.style.display="none"; return; }
    let end = parseInt(localStorage.getItem(TKEY)||"0",10);
    if(!end || end < Date.now()){ end = Date.now() + RESERVE_MIN*60*1000; localStorage.setItem(TKEY, String(end)); }
    const s = Math.max(0, Math.floor((end - Date.now())/1000));
    el.style.display="flex";
    el.querySelector("b").textContent = String(Math.floor(s/60)).padStart(2,"0") + ":" + String(s%60).padStart(2,"0");
  }

  const trashSvg = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
  const stars = n => '<span class="mbc-stars">★★★★★</span><span class="mbc-stars-n">( '+n+' )</span>';

  // prezzo card upsell con barrato + sconto %
  function cardPriceHtml(p, c){
    if(c && c > p){
      return '<span class="mbc-card-now">'+EUR(p)+'</span> <s class="mbc-card-was">'+EUR(c)+'</s>'+
             ' <span class="mbc-card-off">−'+Math.round((1-p/c)*100)+'%</span>';
    }
    return '<span class="mbc-card-now">'+EUR(p)+'</span>';
  }
  // prezzo/barrato per il valore del <select> upsell (f:<fmt> statico | v:<id> Shopify)
  function upsellPC(id, val){
    if((val||"").indexOf("v:")===0){
      const vid=parseInt(val.slice(2),10), e=(window.MB_VARIANTS||{})[id];
      const v=e && e.variants.find(x=>x.id===vid);
      return v ? {p:v.price/100, c:v.compare?v.compare/100:null} : {p:0,c:null};
    }
    const f=fmtsOf(id)[val.slice(2)] || fmtsOf(id).ebook;
    return {p:f.p, c:f.c||null};
  }
  // <select> per cambiare il formato direttamente nella riga del carrello
  function lineFmtSelect(it){
    const suffix = it.id==="bundle" ? " · 4 Bände" : "";
    const mv=(window.MB_VARIANTS||{})[it.id];
    let opts;
    if(mv){
      opts=mv.variants.map(v=>({ value:"v:"+v.id, label:v.option+suffix, sel:v.id===it.variantId }));
    } else {
      const cur=(it.key.split("|")[1]||""), fs=fmtsOf(it.id);
      opts=Object.keys(fs).map(f=>({ value:"f:"+f, label:fs[f].n+suffix, sel:f===cur }));
    }
    return '<select class="mbc-line-fmt" data-mbc-linefmt="'+it.key+'" data-id="'+it.id+'" aria-label="Format ändern">'+
      opts.map(o=>'<option value="'+o.value+'"'+(o.sel?" selected":"")+'>'+o.label+'</option>').join("")+'</select>';
  }

  /* ---- festa allo sblocco spedizione gratuita ---- */
  let wasUnlocked = null;
  function celebrate(){
    const dr=document.getElementById("mbc-dr"), goal=document.getElementById("mbc-goal"), ship=document.getElementById("mbc-ship");
    if(goal){ goal.classList.remove("mbc-pop"); void goal.offsetWidth; goal.classList.add("mbc-pop"); }
    if(ship){ ship.classList.remove("mbc-bounce"); void ship.offsetWidth; ship.classList.add("mbc-bounce"); }
    if(!dr || !goal) return;
    const o=goal.getBoundingClientRect(), d=dr.getBoundingClientRect();
    const colors=["#D53A2F","#1E4D6F","#FDB600","#1f8a4c","#f2b8b3"];
    for(let i=0;i<36;i++){
      const c=document.createElement("div");
      c.className="mbc-conf no-empty";
      const size=6+Math.random()*6;
      c.style.cssText="position:absolute;z-index:5;pointer-events:none;border-radius:"+(Math.random()<.5?"50%":"2px")+
        ";width:"+size+"px;height:"+(size*0.6+2)+"px;background:"+colors[i%colors.length]+
        ";left:"+(o.left-d.left+o.width/2)+"px;top:"+(o.top-d.top+o.height/2)+"px";
      dr.appendChild(c);
      const ang=Math.random()*Math.PI*2, dist=90+Math.random()*200;
      const dx=Math.cos(ang)*dist, dy=Math.sin(ang)*dist*0.6-80;
      const anim=c.animate(
        [{transform:"translate(0,0) rotate(0deg)",opacity:1},
         {transform:"translate("+dx+"px,"+(dy+170)+"px) rotate("+(380+Math.random()*340)+"deg)",opacity:0}],
        {duration:950+Math.random()*550, easing:"cubic-bezier(.15,.55,.45,1)"});
      anim.onfinish=()=>c.remove();
    }
  }

  async function render(){
    await refreshCart();
    const n = cartCache.count;
    document.querySelectorAll("[data-mbc-count], .cart-count").forEach(e=>{ e.textContent = n; });
    const body = document.getElementById("mbc-body"); if(!body) return;

    /* righe */
    body.innerHTML = cartCache.items.length ? cartCache.items.map(it => `<div class="mbc-line">
        <img src="${it.image || coverOf(it.id) || ""}" alt="">
        <div class="mbc-mid">
          <div class="mbc-nm">${it.title}</div>
          ${lineFmtSelect(it)}
          ${it.compare ? '<div class="mbc-deal">Sparen '+Math.round((1-it.line/it.compare)*100)+' %</div>' : ""}
          <div class="mbc-qty"><button data-mbc-bump="${it.key}|${it.qty-1}" aria-label="Menge verringern">−</button><span>${it.qty}</span><button data-mbc-bump="${it.key}|${it.qty+1}" aria-label="Menge erhöhen">+</button></div>
        </div>
        <div class="mbc-right">
          <button class="mbc-rm" data-mbc-bump="${it.key}|0" aria-label="Aus dem Warenkorb entfernen">${trashSvg}</button>
          <div class="mbc-pr">${EUR(it.line)}${it.compare ? ' <s>'+EUR(it.compare)+'</s>' : ""}</div>
        </div>
      </div>`).join("") : `<div class="mbc-empty">Dein Warenkorb ist leer.</div>`;

    /* barra spedizione gratuita */
    const sub = cartCache.total;
    const _sx = cartCache.items.some(i=>["m2","m3","heilpraktiker"].includes(i.id)), _mixed = false, FS = _sx ? 149 : FREE_SHIP;
    const pct = Math.min(100, sub/FS*100);
    const fill=document.getElementById("mbc-fill"); if(fill) fill.style.width=pct+"%";
    const unlocked = sub>=FS;
    const dot=document.getElementById("mbc-goal"); if(dot) dot.dataset.on = unlocked ? "1":"0";
    const txt=document.getElementById("mbc-ship");
    if(txt) txt.innerHTML = unlocked ? "🎉 Du hast den <b>kostenlosen Versand</b> freigeschaltet!" : `Dir fehlen noch <b>${EUR(FS-sub)}</b> bis zum <b>kostenlosen Versand</b>!`;
    if(_mixed && txt) txt.textContent = "Versandkosten für die verschiedenen Produkte werden im Checkout berechnet.";
    if(unlocked && wasUnlocked===false) celebrate();
    wasUnlocked = unlocked;

    /* upsell: prodotti non in carrello */
    const up=document.getElementById("mbc-up");
    if(up){
      const inCart=new Set(cartCache.items.map(i=>i.id));
      const _fcBook=cartCache.items.some(i=>["m2","m3","anatomie","heilpraktiker"].includes(i.id));
      const sugg=Object.keys(CATALOG).filter(id=>id==="m2-lernkarten" ? (_fcBook && !inCart.has(id) && (!window.MB_VARIANTS || !!window.MB_VARIANTS[id])) : (!["m2","m3","heilpraktiker"].includes(id) && !inCart.has(id) && !(id!=="bundle" && inCart.has("bundle")))).sort((a,b)=>(b==="m2-lernkarten")-(a==="m2-lernkarten"));
      if(sugg.length && cartCache.items.length){
        up.style.display="block";
        up.querySelector(".mbc-up-strip").innerHTML = sugg.map(id=>{
          const p=CATALOG[id];
          const mv=(window.MB_VARIANTS||{})[id];
          let opts;
          if(mv){
            // varianti reali Shopify, ordinate dal piu economico (ebook primo)
            opts=[...mv.variants].sort((a,b)=>a.price-b.price).map(v=>({
              value:"v:"+v.id, label:v.option, p:v.price/100, c:v.compare?v.compare/100:null })).filter(o=>!(id==="m2-lernkarten" && /gedruckt/i.test(o.label)));
          } else {
            const fs=fmtsOf(id);
            opts=Object.keys(fs).filter(f=>!(id==="m2-lernkarten" && f!=="ebook")).map(f=>({ value:"f:"+f, label:fs[f].n, p:fs[f].p, c:fs[f].c||null }));
          }
          const first=opts[0]; // default = ebook (primo)
          const optionsHtml=opts.map(o=>`<option value="${o.value}">${id==="m2-lernkarten" ? o.label+" — "+EUR(24.99)+" mit Buch" : o.label+" — "+EUR(o.p)}</option>`).join("");
          return `<div class="mbc-card">
            <img src="${coverOf(id)}" alt="">
            <div class="mbc-card-mid">
              <div class="mbc-nm">${p.t}</div>
              ${id==="m2-lernkarten" ? "" : `<div class="mbc-rate">${stars(p.stars)}</div>`}
              <div class="mbc-card-pr" data-mbc-cardpr="${id}">${(id==="m2-lernkarten" ? cardPriceHtml(24.99, first.p) : cardPriceHtml(first.p, first.c))}</div>
              <div class="mbc-card-actions">
                <select class="mbc-card-fmt" data-mbc-fmtsel="${id}">${optionsHtml}</select>
                <button class="mbc-card-add" data-mbc-add="${id}">Hinzufügen</button>
              </div>
            </div>
          </div>`;
        }).join("");
      } else { up.style.display="none"; up.querySelector(".mbc-up-strip").innerHTML=""; }
    }

    /* sconto */
    const chip=document.getElementById("mbc-disc-chip");
    const code=(localStorage.getItem(DKEY)||"").toUpperCase();
    const note=document.getElementById("mbc-disc-note");
    if(chip){
      if(code && (SHOP() || DISCOUNTS[code])){
        chip.style.display="flex"; chip.querySelector("b").textContent=code;
        if(note){ note.style.display="block"; note.textContent = SHOP() ? "Der Rabatt wird beim Checkout angewendet ⌄" : "1 Rabatt auf die Bestellung angewendet ⌄"; }
      } else { chip.style.display="none"; if(note) note.style.display="none"; }
    }

    /* subtotale */
    const st=document.getElementById("mbc-sub");
    const so=document.getElementById("mbc-sub-old");
    const si=document.getElementById("mbc-sub-items");
    if(st) st.textContent=EUR(sub);
    if(si) si.textContent = n===1 ? "(1 Artikel)" : "("+n+" Artikel)";
    if(so){
      // barrato = somma dei prezzi pieni (compare quando c'è, altrimenti riga)
      const full = cartCache.items.reduce((s,i)=>s+(i.compare||i.line),0);
      so.textContent = full > sub + 0.005 ? EUR(full) : "";
    }
    tickTimer();
  }

  async function applyDiscount(){
    const inp=document.getElementById("mbc-disc-in");
    const code=(inp.value||"").trim().toUpperCase();
    if(!code) return;
    if(SHOP()){
      try { await fetch("/discount/"+encodeURIComponent(code)); } catch(e){}
      localStorage.setItem(DKEY, code); inp.value="";
      render();
    } else if(DISCOUNTS[code]){
      localStorage.setItem(DKEY, code); inp.value=""; inp.placeholder="RABATTCODE"; render();
    } else { inp.value=""; inp.placeholder="Ungültiger Code"; }
  }

  function injectDrawer(){
    if(document.getElementById("mbc-dr")) return;
    const css=`<style>
    cart-drawer, #CartDrawer, .cart-drawer:not(#mbc-dr){display:none !important}
    #mbc-ov{position:fixed;inset:0;background:rgba(0,0,0,.45);opacity:0;visibility:hidden;transition:.25s;z-index:99998}
    #mbc-ov[data-open="1"]{opacity:1;visibility:visible}
    #mbc-dr{position:fixed;top:8px;right:8px;bottom:8px;width:min(460px,calc(100vw - 16px));background:#fff;z-index:99999;transform:translateX(calc(100% + 16px));transition:transform .3s cubic-bezier(.4,0,.2,1);display:flex;flex-direction:column;font-family:var(--font-body-family,Montserrat,sans-serif);border-radius:22px;box-shadow:0 18px 50px rgba(0,0,0,.25);overflow:hidden}
    #mbc-dr[data-open="1"]{transform:translateX(0)}
    .mbc-hd{display:flex;align-items:center;justify-content:space-between;padding:18px 24px 6px}
    .mbc-hd b{font-family:var(--font-heading-family,"Passion One",sans-serif);font-weight:400;font-size:28px;line-height:1}
    .mbc-x{font-size:24px;background:none;border:0;cursor:pointer;line-height:1;padding:4px}
    .mbc-ship-w{padding:10px 24px 4px}
    .mbc-track-w{position:relative;height:34px;display:flex;align-items:center}
    .mbc-track{height:10px;border-radius:99px;background:#ececec;overflow:hidden;flex:1}
    .mbc-fill{height:100%;background:#D53A2F;border-radius:99px;width:0;transition:width .4s}
    .mbc-goal{position:absolute;right:0;top:50%;transform:translateY(-50%);width:34px;height:34px;border-radius:50%;background:#fff;border:3px solid #f2b8b3;display:flex;align-items:center;justify-content:center;font-size:15px;color:#f2b8b3;transition:.3s}
    .mbc-goal[data-on="1"]{background:#D53A2F;border-color:#D53A2F;color:#fff}
    .mbc-ship-t{font-size:14.5px;text-align:center;margin:8px 0 2px}.mbc-ship-t b{color:#D53A2F}
    .mbc-timer{display:none;align-items:center;justify-content:center;gap:7px;margin:8px 24px 0;padding:8px 12px;background:#fff7f6;border:1px dashed #f0c7c3;border-radius:12px;font-size:13px;color:#8a4a44}
    .mbc-timer b{font-variant-numeric:tabular-nums;color:#D53A2F;font-size:14px}
    .mbc-bd{flex:1;overflow-y:auto;padding:6px 24px;margin-top:8px}
    .mbc-line{display:flex;gap:14px;padding:13px 0;border-bottom:1px solid #f0f0f0;align-items:flex-start}
    .mbc-line img{width:78px;height:96px;object-fit:contain;background:#f6f6f6;border-radius:10px;flex:0 0 78px}
    .mbc-mid{flex:1;min-width:0}
    .mbc-nm{font-weight:800;font-size:15px;color:#111;line-height:1.25}
    .mbc-fmt{font-size:13.5px;color:#555;margin-top:3px}
    .mbc-line-fmt{margin-top:5px;max-width:100%;font-family:inherit;font-size:13px;color:#333;font-weight:600;border:1.5px solid #e6e6e6;border-radius:9px;padding:6px 26px 6px 10px;background:#fff url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='3' stroke-linecap='round'><path d='M6 9l6 6 6-6'/></svg>") no-repeat right 9px center;-webkit-appearance:none;appearance:none;cursor:pointer}
    .mbc-line-fmt:focus{outline:none;border-color:#74BDEA}
    .mbc-deal{font-size:12.5px;color:#D53A2F;font-weight:700;margin-top:2px}
    .mbc-qty{display:inline-flex;align-items:center;margin-top:10px;border:1.5px solid #e6e6e6;border-radius:99px;overflow:hidden;background:#fff}
    .mbc-qty button{width:34px;height:32px;background:#fff;border:0;font-size:17px;cursor:pointer;line-height:1;color:#222}
    .mbc-qty button:hover{background:#f3f3f3}
    .mbc-qty span{min-width:30px;text-align:center;font-size:14px;font-weight:800}
    .mbc-right{display:flex;flex-direction:column;align-items:flex-end;gap:26px}
    .mbc-rm{background:none;border:0;color:#999;cursor:pointer;padding:2px;border-radius:6px}
    .mbc-rm:hover{color:#D53A2F}
    .mbc-pr{font-weight:800;font-size:15px;color:#D53A2F;white-space:nowrap}
    .mbc-pr s{color:#9b9b9b;font-weight:600;font-size:13.5px;margin-left:4px}
    .mbc-empty{text-align:center;color:#999;padding:48px 0}
    .mbc-up{margin:12px 0 6px}
    .mbc-up-hd{display:flex;align-items:center;justify-content:space-between;margin-bottom:10px}
    .mbc-up-hd b{font-family:var(--font-heading-family,"Passion One",sans-serif);font-weight:400;font-size:20px}
    .mbc-up-nav button{background:none;border:0;font-size:20px;cursor:pointer;color:#333;padding:2px 6px}
    .mbc-up-strip{display:flex;gap:12px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;-ms-overflow-style:none}
    .mbc-up-strip::-webkit-scrollbar{display:none}
    .mbc-card{flex:0 0 100%;width:100%;min-width:0;max-width:100%;box-sizing:border-box;scroll-snap-align:start;display:flex;gap:12px;align-items:flex-start;border:1px solid #ececec;border-radius:16px;padding:14px}
    .mbc-card img{width:72px;height:72px;object-fit:contain;background:#f6f6f6;border-radius:10px;flex:0 0 72px}
    .mbc-card-mid{flex:1;min-width:0}
    .mbc-rate{margin-top:2px;display:flex;align-items:center;gap:5px}
    .mbc-stars{color:#FDB600;font-size:13px;letter-spacing:1px;white-space:nowrap}.mbc-stars-n{font-size:12px;color:#777;white-space:nowrap}
    .mbc-card .mbc-nm{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:14.5px}
    .mbc-card-pr{font-weight:800;font-size:14px;margin-top:3px;display:flex;align-items:baseline;gap:6px;flex-wrap:wrap;line-height:1.1}
    .mbc-card-now{color:#D53A2F}
    .mbc-card-was{color:#9b9b9b;font-weight:600;font-size:12.5px}
    .mbc-card-off{color:#D53A2F;font-weight:800;font-size:11.5px}
    .mbc-card-actions{display:flex;gap:8px;align-items:center;margin-top:8px}
    .mbc-card-fmt{flex:1 1 auto;min-width:0;font-size:12.5px;padding:8px 9px;border:1.5px solid #e6e6e6;border-radius:10px;background:#fff;color:#333}
    .mbc-card-add{background:#D53A2F;color:#fff;border:0;font-weight:800;font-size:13px;padding:10px 14px;border-radius:99px;cursor:pointer;flex:0 0 auto;white-space:nowrap}
    .mbc-card-add:hover{background:#b73225}
    .mbc-disc{padding:14px 24px 0}
    .mbc-disc-row{display:flex;gap:10px}
    .mbc-disc-row input{flex:1;border:1.5px solid #e2e2e2;border-radius:99px;padding:13px 18px;font-size:13.5px;letter-spacing:.05em;outline:none;text-transform:uppercase;min-width:0}
    .mbc-disc-row input:focus{border-color:#bbb}
    .mbc-disc-row button{background:#f1f1f1;border:0;font-weight:700;font-size:15px;padding:0 24px;border-radius:99px;cursor:pointer}
    .mbc-disc-chip{display:none;align-items:center;gap:8px;background:#f1f1f1;border-radius:10px;padding:7px 12px;margin-top:10px;width:max-content;font-size:13px;font-weight:800;letter-spacing:.04em}
    .mbc-disc-chip button{background:none;border:0;cursor:pointer;font-size:14px;color:#666;padding:0 2px}
    .mbc-disc-note{display:none;font-size:12.5px;font-weight:700;color:#777;margin-top:8px}
    .mbc-ft{padding:12px 24px 16px}
    .mbc-subt{display:flex;justify-content:space-between;align-items:baseline;gap:10px;font-weight:800;margin-bottom:10px;font-size:15px}
    .mbc-subt>span:first-child{white-space:nowrap}
    #mbc-sub-items{font-weight:600;font-size:12px;color:#8a8a90}
    .mbc-subt .mbc-sub-pr{color:#D53A2F;white-space:nowrap}
    .mbc-subt .mbc-sub-pr s#mbc-sub-old{color:#9b9b9b;font-weight:600;font-size:13px;margin-left:6px}
    .mbc-co{display:block;width:100%;text-align:center;background:#D53A2F;color:#fff;font-weight:800;padding:16px;border-radius:99px;text-decoration:none;font-size:16.5px;border:0;cursor:pointer}
    .mbc-co:hover{background:#b73225}
    .mbc-note{font-size:10.5px;color:#aaa;text-align:center;margin-top:7px}
    .mbc-trust{display:flex;flex-wrap:nowrap;justify-content:center;gap:10px;margin-top:8px}
    .mbc-trust span{display:inline-flex;align-items:center;gap:4px;font-size:10px;font-weight:600;color:#8a8a90;white-space:nowrap}
    .mbc-trust svg{width:12px;height:12px;flex:0 0 auto;color:#aab0b8}
    .mbc-klarna2{display:flex;align-items:center;justify-content:center;gap:6px;flex-wrap:nowrap;margin-top:7px;font-size:10.5px;color:#7a7a80;white-space:nowrap}
    .mbc-klarna2 b{color:#1E4D6F;font-weight:700}
    .mbc-kl2-logo{height:14px;width:auto;display:inline-block;vertical-align:middle}
    .mbc-kl2-fb{background:#FFB3C7;color:#17120f;font-weight:800;border-radius:4px;padding:0 5px;font-size:10px}
    .mb-fmt-required{outline:2px solid #D53A2F;outline-offset:6px;border-radius:8px}
    .mb-fmt-err{color:#D53A2F;font-size:13px;font-weight:700;margin-top:10px}
    @keyframes mbcPop{0%{transform:translateY(-50%) scale(1)}40%{transform:translateY(-50%) scale(1.5)}70%{transform:translateY(-50%) scale(.9)}100%{transform:translateY(-50%) scale(1)}}
    .mbc-goal.mbc-pop{animation:mbcPop .7s cubic-bezier(.34,1.56,.64,1)}
    @keyframes mbcBounce{0%{transform:scale(.85);opacity:.3}60%{transform:scale(1.07)}100%{transform:scale(1)}}
    .mbc-ship-t.mbc-bounce{animation:mbcBounce .5s ease-out}
    @media(max-width:600px){
      #mbc-dr{top:0;right:0;bottom:0;width:100vw;border-radius:0}
      .mbc-hd{padding:15px 16px 6px}.mbc-hd b{font-size:23px}
      .mbc-ship-w{padding:8px 16px 2px}.mbc-ship-t{font-size:13px}
      .mbc-bd{padding:4px 16px}
      .mbc-line{gap:11px;padding:13px 0}
      .mbc-line img{width:56px;height:72px;flex:0 0 56px}
      .mbc-nm{font-size:14px}.mbc-fmt{font-size:12.5px}
      .mbc-qty{margin-top:8px}.mbc-qty button{width:30px;height:28px;font-size:16px}.mbc-qty span{min-width:26px;font-size:13px}
      .mbc-pr{font-size:14px}.mbc-right{gap:16px}
      .mbc-up{margin:14px 0 4px}.mbc-up-hd b{font-size:18px}
      .mbc-card{flex:0 0 100%;gap:10px;padding:11px}
      .mbc-card img{width:60px;height:60px;flex:0 0 60px}
      .mbc-nm{line-height:1.2}.mbc-card-add{padding:9px 14px;font-size:12.5px}
      .mbc-ft{padding:12px 16px 16px}.mbc-subt{font-size:14px}.mbc-co{padding:14px;font-size:15.5px}
    }
    </style>`;
    /* class "no-empty": il tema nasconde i div vuoti (div:empty{display:none}) */
    const html=`<div id="mbc-ov" class="no-empty" data-mbc-close></div>
    <aside id="mbc-dr" aria-label="Warenkorb">
      <div class="mbc-hd"><b>Dein Warenkorb</b><button class="mbc-x" data-mbc-close>✕</button></div>
      <div class="mbc-ship-w">
        <div class="mbc-track-w no-empty">
          <div class="mbc-track no-empty"><div class="mbc-fill no-empty" id="mbc-fill"></div></div>
          <div class="mbc-goal no-empty" id="mbc-goal" data-on="0">✓</div>
        </div>
        <div class="mbc-ship-t no-empty" id="mbc-ship"></div>
      </div>
      <div class="mbc-timer" id="mbc-timer">⏳ Dein Warenkorb ist für <b>10:00</b> reserviert</div>
      <div class="mbc-bd">
        <div id="mbc-body" class="no-empty"></div>
        <div class="mbc-up no-empty" id="mbc-up" style="display:none">
          <div class="mbc-up-hd"><b>Das könnte dir gefallen</b><span class="mbc-up-nav"><button data-mbc-scroll="-1" aria-label="Zurück">‹</button><button data-mbc-scroll="1" aria-label="Weiter">›</button></span></div>
          <div class="mbc-up-strip no-empty"></div>
        </div>
      </div>
      <div class="mbc-ft">
        <div class="mbc-subt"><span>Zwischensumme <span id="mbc-sub-items"></span></span><span class="mbc-sub-pr"><span id="mbc-sub">€0,00</span><s id="mbc-sub-old" class="no-empty"></s></span></div>
        <a class="mbc-co" id="mbc-co" href="#">Checkout</a>
        <div class="mbc-note">Versand und Steuern werden beim Checkout berechnet</div>
        <div class="mbc-trust no-empty">
          <span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>Sichere Zahlung</span>
          <span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 2.6-6.4L3 8"/><path d="M3 3v5h5"/></svg>14 Tage Rückgabe</span>
          <span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v8H3z"/><path d="M14 10h4l3 3v2h-7z"/><circle cx="7.5" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>Gratis ab €149</span>
        </div>
      </div>
    </aside>`;
    document.body.insertAdjacentHTML("beforeend", css+html);
    var dgo=document.getElementById("mbc-disc-go"); if(dgo) dgo.addEventListener("click", applyDiscount);
    var din=document.getElementById("mbc-disc-in"); if(din) din.addEventListener("keydown", e=>{ if(e.key==="Enter") applyDiscount(); });
    if(SHOP()) document.getElementById("mbc-co").setAttribute("href", "/checkout");
    if(!timerInt) timerInt = setInterval(tickTimer, 1000);
  }

  function init(){
    injectDrawer();
    // cambio formato nelle card upsell -> aggiorna il prezzo mostrato (barrato incluso)
    document.addEventListener("change", e => {
      // cambio formato card upsell -> aggiorna prezzo mostrato
      const sel = e.target.closest && e.target.closest("[data-mbc-fmtsel]");
      if(sel){
        const id = sel.dataset.mbcFmtsel;
        const pr = document.querySelector('[data-mbc-cardpr="'+id+'"]');
        if(pr){ const pc = upsellPC(id, sel.value); pr.innerHTML = cardPriceHtml(pc.p, pc.c); }
        return;
      }
      // cambio formato di una riga gia nel carrello
      const lsel = e.target.closest && e.target.closest("[data-mbc-linefmt]");
      if(lsel){
        const oldKey = lsel.dataset.mbcLinefmt;
        const item = cartCache.items.find(i => i.key===oldKey);
        changeLineFmt(oldKey, lsel.dataset.id, lsel.value, item ? item.qty : 1);
      }
    });
    document.addEventListener("click", e => {
      const closeBtn = e.target.closest("[data-mbc-close]"); if(closeBtn){ e.preventDefault(); close(); return; }
      const bumpBtn = e.target.closest("[data-mbc-bump]"); if(bumpBtn){
        const parts = bumpBtn.dataset.mbcBump.split("|");
        const qty = parseInt(parts.pop(),10);
        setQty(parts.join("|"), qty); return;
      }
      const sc = e.target.closest("[data-mbc-scroll]"); if(sc){ const strip=document.querySelector(".mbc-up-strip"); if(strip) strip.scrollBy({left:parseInt(sc.dataset.mbcScroll,10)*strip.clientWidth*0.92, behavior:"smooth"}); return; }
      const drm = e.target.closest("[data-mbc-disc-rm]"); if(drm){ localStorage.removeItem(DKEY); render(); return; }
      const up = e.target.closest("[data-mbc-add]"); if(up){ e.preventDefault();
        const id=up.dataset.mbcAdd;
        const sel=document.querySelector('select[data-mbc-fmtsel="'+id+'"]');
        const val=sel ? sel.value : "f:ebook";
        if(val.startsWith("v:")) addVariantId(parseInt(val.slice(2),10), 1);
        else addLine(id, val.slice(2), 1);
        return; }
      const ups = e.target.closest("[data-ups-add]"); if(ups){ e.preventDefault(); addLine(ups.dataset.upsAdd, ups.dataset.upsAdd === "anatomie" ? "spiral" : "ebook", 1); return; }
      // pulsante "aggiungi al carrello" / "In den Warenkorb" della pagina prodotto
      // rilevato per SELETTORE (non per testo, così funziona in qualsiasi lingua); pageId() sotto fa da guardia
      const atc = e.target.closest('button[name="add"], .product-form__submit');
      if(atc && !atc.closest("#mbc-dr")){
        e.preventDefault(); e.stopPropagation();
        const id = pageId();
        if(!id) return;
        // Se il click arriva dalla sticky bar, il formato/quantità li leggo dal suo
        // <select> (ha sempre un valore: default ebook), così l'aggiunta funziona
        // anche senza aver toccato i radio principali.
        const sb = atc.closest(".sticky-atc-bar");
        let fmt, qty;
        if(sb){
          const ss = sb.querySelector(".sticky-atc-bar__variant-select");
          const o = ss ? ss.options[ss.selectedIndex] : null;
          fmt = o ? fmtOf(o.textContent) : currentFmt();
          const sq = sb.querySelector('.quantity__input, input[type="number"]');
          qty = sq ? Math.max(1, parseInt(sq.value,10)||1) : currentQty();
        } else {
          fmt = currentFmt(); qty = currentQty();
        }
        if(!fmt){ showFormatError(); return; } // formato obbligatorio (solo area prodotto)
        addLine(id, fmt, qty);
        return;
      }
      // icona carrello header -> drawer custom
      const ci = e.target.closest('a[href$="/cart"], a[href*="/cart?"], a[href$="cart"], [aria-label*="cart" i], [aria-label*="carrello" i], [aria-label*="warenkorb" i], [class*="header__cart" i], [class*="cart-icon" i], [class*="js-cart" i], .cart-drawer-button');
      if(ci && !ci.closest("#mbc-dr") && !ci.matches("[data-mbc-add],[data-ups-add]")){ e.preventDefault(); e.stopPropagation(); open(); }
    }, true);
    render();
  }
  window.__mbc = { open, close, add: addLine, render };
  if(document.readyState!=="loading") init(); else document.addEventListener("DOMContentLoaded", init);
})();
